/*
 *  I01TEMPATTCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-02 12:26:07 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchTube } from '@batical/data/src'
import { RTubes_Type, I01TEMPATT_State } from '@batical/types/src'

import { volumeEauFroide, tempsAttenteAvantEauChaudeSimple } from '../CommonFormula'

function I01TEMPATT_docalcul(state: I01TEMPATT_State) {
  if (state.in_longConduit > 0 && state.in_debitPuisage > 0 && state.tube_uuid.length > 0) {
    const tube: RTubes_Type = fetchTube(state.tube_uuid)
    state.res_volEauFroid = volumeEauFroide(tube.diamInt / 1000, state.in_longConduit)
    state.res_tpsAttenteEauChaude = tempsAttenteAvantEauChaudeSimple(state.res_volEauFroid, state.in_debitPuisage)
  } else {
    state.res_volEauFroid = 0
    state.res_tpsAttenteEauChaude = 0
  }
  state.invalidated = false
  return state
}

export default I01TEMPATT_docalcul
